import type { StoreReview } from '@eliadmin/core/src/api/general/general-api';

export function storeReviewsQueryOptions(locale: string) {
  return {
    queryKey: [
      'saprem-store-reviews-v1',
      process.env.NEXT_PUBLIC_API_URL ?? '',
      process.env.NEXT_PUBLIC_CURRENT_STORE ?? '',
      locale,
    ],
    staleTime: 5 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    queryFn: async ({ signal }: { signal: AbortSignal }): Promise<StoreReview[]> => {
      const response = await fetch(`/api/store-reviews?${new URLSearchParams({ locale })}`, {
        headers: { Accept: 'application/json' },
        signal,
      });
      if (!response.ok) throw new Error('Store reviews are temporarily unavailable.');
      const payload = (await response.json()) as { data?: StoreReview[] };
      if (!Array.isArray(payload.data)) throw new Error('Invalid store reviews response.');
      return payload.data;
    },
  };
}
